/*
 * "Added to your bag" panel (snippets/halo-cart-popup-1.liquid), styled after thehouseofrare.com.
 *
 * The theme's own add-to-cart code still does all the work: it adds the item, fills the
 * panel's image and title (halo.updatePopupCart in theme.js), refreshes the cart drawer and
 * opens the panel. This file only adds the size, the price and a "You may also like" row
 * once the panel opens, and makes VIEW BAG open the cart drawer. theme.js is not modified.
 */
(function () {
  const popup = document.getElementById('halo-add-to-cart-popup');
  if (!popup || !popup.classList.contains('epg-added')) return;

  const body = document.body;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const image = popup.querySelector('.product-added .product-image');
  const titleLink = popup.querySelector('.product-title .title');
  const meta = popup.querySelector('[data-epg-added-meta]');
  const price = popup.querySelector('[data-epg-added-price]');
  const recs = popup.querySelector('[data-epg-recs]');
  const recsList = popup.querySelector('[data-epg-recs-list]');
  const viewBag = popup.querySelector('[data-epg-view-bag]');
  const productCache = new Map();
  const recsCache = new Map();
  let token = 0;
  let wasOpen = false;
  let queued = false;

  const isOpen = () => body.classList.contains('add-to-cart-show');

  function money(cents) {
    let out = '';
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.money_format) {
        out = String(window.Shopify.formatMoney(cents, window.money_format)).replace(/<[^>]*>/g, '').trim();
      }
    } catch (error) {
      out = '';
    }
    // Unsupported money formats come back without an amount.
    if (!/\d/.test(out)) out = '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
    return out;
  }

  function sized(src, width) {
    if (!src) return '';
    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', width);
      return url.toString();
    } catch (error) {
      return src;
    }
  }

  function fetchJSON(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((response) => {
      if (!response.ok) throw new Error(response.status);
      return response.json();
    });
  }

  function getProduct(handle) {
    if (!productCache.has(handle)) {
      const request = fetchJSON(root + 'products/' + encodeURIComponent(handle) + '.js');
      request.catch(() => productCache.delete(handle));
      productCache.set(handle, request);
    }
    return productCache.get(handle);
  }

  function getRecs(productId) {
    if (!recsCache.has(productId)) {
      const request = fetchJSON(root + 'recommendations/products.json?product_id=' + productId + '&limit=8&intent=related')
        .then((data) => (data && data.products) || []);
      request.catch(() => recsCache.delete(productId));
      recsCache.set(productId, request);
    }
    return recsCache.get(productId);
  }

  // The theme links the title to the added item's URL: /products/<handle>?variant=<id>.
  function readLink() {
    const href = titleLink && titleLink.getAttribute('href');
    if (!href) return null;
    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return null;
    }
    const match = url.pathname.match(/\/products\/([^/]+)/);
    if (!match) return null;
    return { handle: decodeURIComponent(match[1]), variantId: Number(url.searchParams.get('variant')) || null };
  }

  function optionText(product, variant) {
    if (!variant || variant.title === 'Default Title') return '';
    const names = (product.options || []).map((option) => (typeof option === 'string' ? option : option.name));
    const values = variant.options || [variant.option1, variant.option2, variant.option3];
    const sizeIndex = names.findIndex((name) => /size/i.test(name || ''));
    if (sizeIndex > -1 && values[sizeIndex]) return names[sizeIndex] + ': ' + values[sizeIndex];
    if (names.length === 1 && values[0]) return names[0] + ': ' + values[0];
    return variant.title;
  }

  function priceNodes(target, now, was, classPrefix) {
    target.textContent = '';
    const current = document.createElement('span');
    current.className = classPrefix + '__now';
    current.textContent = money(now);
    target.appendChild(current);
    if (was && was > now) {
      const struck = document.createElement('s');
      struck.className = classPrefix + '__was';
      struck.textContent = money(was);
      target.appendChild(struck);
      const off = document.createElement('span');
      off.className = classPrefix + '__off';
      off.textContent = Math.round(((was - now) * 100) / was) + '% off';
      target.appendChild(off);
    }
  }

  function renderRecs(products, currentId) {
    if (!recs || !recsList) return;
    const list = products.filter((item) => item.id !== currentId && item.available !== false).slice(0, 6);
    recsList.textContent = '';
    list.forEach((item) => {
      const card = document.createElement('a');
      card.className = 'epg-rec';
      card.href = item.url || root + 'products/' + item.handle;

      const media = document.createElement('span');
      media.className = 'epg-rec__media';
      const src = item.featured_image || (item.images && item.images[0]);
      if (src) {
        const img = document.createElement('img');
        img.className = 'epg-rec__img';
        img.src = sized(src, 300);
        img.srcset = sized(src, 300) + ' 300w, ' + sized(src, 450) + ' 450w';
        img.sizes = '160px';
        img.width = 300;
        img.height = 375;
        img.loading = 'lazy';
        img.alt = '';
        media.appendChild(img);
      }
      card.appendChild(media);

      const title = document.createElement('span');
      title.className = 'epg-rec__title';
      title.textContent = item.title;
      card.appendChild(title);

      const itemPrice = document.createElement('span');
      itemPrice.className = 'epg-rec__price';
      priceNodes(itemPrice, item.price, item.compare_at_price, 'epg-rec');
      card.appendChild(itemPrice);

      recsList.appendChild(card);
    });
    recs.hidden = list.length === 0;
  }

  function refresh() {
    const link = readLink();
    if (!link) return;
    const current = ++token;
    meta.textContent = '';
    price.textContent = '';
    if (recs) recs.hidden = true;

    getProduct(link.handle)
      .then((product) => {
        if (current !== token) return null;
        const variant = product.variants.find((item) => item.id === link.variantId) || product.variants[0];
        // The theme's title is "<product> - <variant>"; the size gets its own line here.
        titleLink.textContent = product.title;
        meta.textContent = optionText(product, variant);
        if (variant) priceNodes(price, variant.price, variant.compare_at_price, 'epg-added');
        if (!recs) return null;
        return getRecs(product.id).then((list) => {
          if (current === token) renderRecs(list, product.id);
        });
      })
      .catch(() => {
        // Keep whatever the theme rendered (image and "<product> - <variant>" title).
      });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    Promise.resolve().then(() => {
      queued = false;
      if (isOpen()) refresh();
    });
  }

  // Opening the panel: the theme adds `add-to-cart-show` to <body> right after filling it.
  new MutationObserver(() => {
    const open = isOpen();
    if (open && !wasOpen) {
      schedule();
      popup.focus({ preventScroll: true });
    }
    wasOpen = open;
  }).observe(body, { attributes: true, attributeFilter: ['class'] });

  // The theme replaces the image on every add, including one made while the panel is open.
  // Only the theme writes there, so this never reacts to changes made by this file.
  if (image) new MutationObserver(schedule).observe(image, { childList: true });

  if (viewBag) {
    viewBag.addEventListener('click', (event) => {
      // Without the cart drawer, the link goes to the cart page.
      if (!document.getElementById('halo-cart-sidebar')) return;
      event.preventDefault();
      event.stopPropagation();
      body.classList.remove('add-to-cart-show');
      body.classList.add('cart-sidebar-show');
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen()) body.classList.remove('add-to-cart-show');
  });
})();
